import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class PrivateRoute extends Route {
  @service router;

  setupController(controller, model) {
    super.setupController(controller, model);
    const application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
  }

  beforeModel(/*transition*/) {
    this.router.transitionTo('list', {
      queryParams: {
        type: 'private',
      },
    });
  }
}
